var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('div',{staticClass:"message-body"},[_c('p',{staticClass:"title is-6 fancy"},[_vm._v("\n      "+_vm._s(_vm.date)+"\n    ")]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }